<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>

      <el-main style="overflow-x: hidden;" v-loading.fullscreen.lock="loading">
        <el-form ref="form" label-width="200px" >
          <el-row>
            <el-col :span="9">
              <el-form-item :label="$t('field.demandDate')">
                <el-col :span="11">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdate" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2" style='text-align: center;'>-</el-col>
                <el-col :span="11">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="edate" style="width: 100%;"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="11">    
              <el-form-item :label="$t('field.customerNo')"  >
                <el-select v-model="custSapCode" :placeholder="$t('msg.pleaseSelect')" style="width:100%"  clearable >
                  <el-option v-for="item in custSapNoOpts"  :key="item.key"  :label="item.value" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>  
          <el-row>
            <el-col :span="24" style="text-align:center">
              <el-button type="primary" @click="search"  size="small">{{$t('button.search')}}</el-button>
              <el-button type="success" @click="createTraining"  size="small">{{$t('button.apply')}}</el-button>
              <el-button type="warning" @click="descOpen"  size="small">{{$t('button.trainingOutline')}}</el-button>
              <el-button type="warning" @click="downloadTutorial"  size="small">{{$t('button.trainingDescription')}}</el-button>
            </el-col>             
          </el-row>   
        </el-form>
  
        <el-row>   
         <Table ref="resultTable" :tableData="tableData" :checkAction="checkAction"  :linkAction="linkAction"  @reload-data-by-sort="reloadDataBySort"/> 
    
        </el-row>
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%" >     
          <img src="..//..//assets/training_item_desc.png" style=" max-height: 100%; max-width: 100%; "/>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">{{$t('button.confirm')}}</el-button>
          </span>
        </el-dialog>
    </el-main>
  </div>
</template>

<script>

import Table from '../components/FuzzySearchTableWithRemoteSort'
import Breadcrumb from '../components/Breadcrumb'
import { apiFindTrainingByCondition, apiTrainingSave, apiCustConfirm, apiFindCustSapNoByWindowsAccount,apiCreateTraining } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";
import AWSUtil from "../../utils/AWSUtil";

const AWS = require('aws-sdk')

AWS.config.update({
  region: AWSUtil.getBucketRegion(),
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: AWSUtil.getIdentityPoolId()
  })
});
var s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: AWSUtil.getAlbumBucketName() },
  httpOptions: {
		timeout: 30*1000*60,
	},
});

export default {
  name: 'trainingFae',
  data() {    
    return { 
      loading:false, 
      addDataSuccess: false,   
      sdate: '',
      edate: '',     
      custSapCode:'',
      custSapNoOpts:[],
      sortColumn:'',
      sortType:'',   
      tableData: {
        sel: null,   
        columns: [
          { field: "applyDateStr", title:this.$i18n.t('field.demandDate') , width: 150, align:'center', notUpdate:true},
          { field: "status", title: this.$i18n.t('field.status'), width: 100 , notUpdate:true},
          { field: "applyBy", title: this.$i18n.t('field.requestAccount'), width: 180 , notUpdate:true},
          { field: "custSapCodeStr", title: this.$i18n.t('field.sortl'),width: 210, notUpdate:true },
          { field: "fae", title: 'INCX FAE' ,width: 140, notUpdate:true },
          { field: "trainingDate", title: 'Educational Training  Date' ,width: 250 },
          { field: "name", title: 'Educational Training Item',width: 250  },
          { field: "remark", title: 'Information',width: 350 },
          { field: "faeClosedTimeStr", title: 'FAE case closed' ,width: 200 ,notUpdate:true },
          { field: "closeRemark", title: 'Closed Remark',width: 200},
          { field: "custConfirmTimeStr", title: 'Customer confirmation',width: 220 ,notUpdate:true,checkbox:'true', tooltip:this.$i18n.t('field.clickConfirm') },
          { field: "fileName", title: 'File',width: 200 ,link:true, type:"file"}
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1 ,
        tableId:'trainingTable',
        exportName: this.$i18n.t('menu.softwareVersion')
      },
      dialogVisible:false,
      dialogTitle:'Educational Training Item Description'    
    };
  }, 
  components: {
    Breadcrumb,
    Table
  },
  created(){
    debugger
    apiFindCustSapNoByWindowsAccount({ headers: authHeader()}).then((response) => { 
      if(response.status== 200 && response.data != null){
   
        response.data.forEach((rec, index) => {   
          this.custSapNoOpts.push({ key:rec.key, value: rec.value});
        });  
        if(response.data.length == 1){
          this.custSapCode = this.custSapNoOpts[0].key;
        }
       
      }
    }).catch((err) => {
      console.log(err);
    });
  },
  mounted() {  

    this.findData()
    
  },
  methods: {
    findData(){
      var sdate = '', edate = '';
      if(this.sdate != null && this.sdate != ''){        
        sdate = this.sdate.getFullYear() +''+ CommonUtil.lpad(this.sdate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.sdate.getDate(), 2);
      }
       if(this.edate != null && this.edate != ''){        
        edate = this.edate.getFullYear() +''+ CommonUtil.lpad(this.edate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.edate.getDate(), 2);
      }

      this.tableData.data = [];
      this.tableData.originalTableData =  [];  
      apiFindTrainingByCondition({ headers: authHeader(), sdate: sdate, edate: edate, condition1:this.custSapCode, sortColumn: this.sortColumn, sortType:this.sortType}).then((response) => { 
          var reg=new RegExp("<br>","g");
          response.data.forEach((rec, index) => {   
            if(rec.remark != null){
              rec.remark = rec.remark.replace(reg,"\n"); 
            }            
          }); 
          this.tableData.data = response.data;  
          this.tableData.originalTableData =  this.tableData.data;  

      }).catch((err) => {
        console.log(err);
      });
    },
    search() {
      this.findData();
    },
    descOpen(){
      this.dialogVisible = true;
    },
    downloadTutorial(){
      this.loading = true;
      var folder = 'cust/other/training/20230220_CTIMS教育訓練SOP_.pdf';
      debugger
      const getFile = s3.getObject({Bucket: AWSUtil.getAlbumBucketName(), Key: folder}).promise();  

      getFile.then((data) => {   
          this.loading = false;
          const url = window.URL.createObjectURL(new Blob([data.Body]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', '20230220_CTIMS教育訓練SOP_.pdf')
          document.body.appendChild(link)
          link.click()
        }).catch((err) => {   
          this.loading = false;
          return alert("There was an error downloading your file: ", err.message);
        });
    }, 
    reloadDataBySort(sortColumn, sortType){
      this.sortColumn = sortColumn;
      this.sortType = sortType;
      debugger
      this.findData()
    },
    checkAction(row, index, a, field){ 
           
      const msg = this.$i18n.t('msg.trainingFaeClosedConfirm').replace('{item}', row.name);      
      this.$confirm(msg, {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {
        this.loading = true;        
        apiCustConfirm({ headers: authHeader(), id:row.id }).then((response) => {    
          if(response.status == 200){
            this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});     
            this.findData();
          }else{
            this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
          }
          this.loading = false;
        }).catch((err) => {
          this.loading = false;
          console.log(err);
        });
        done();
      }).catch(_ => {});   
      
    },
    linkAction(row, index){  
      this.loading = true;
      let subFolder = row.custSapCode.split(' ')[0];
      var folder = 'cust/training/'+ subFolder +'/'+ row.fileName;
debugger

      const getFile = s3.getObject({Bucket: AWSUtil.getAlbumBucketName(), Key: folder}).promise();  


      getFile.then((data) => {         
        this.loading = false;
        const url = window.URL.createObjectURL(new Blob([data.Body]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', row.fileName)
        document.body.appendChild(link)
        link.click()
      }).catch((err) => {     
        debugger     
        this.loading = false;
        return alert("There was an error downloading your file: ", err.message);
      });      
    },
    createTraining(){      
      if(this.custSapCode != null && this.custSapCode != ''){
        const msg = this.$i18n.t('msg.createTrainingConfirm');      
        this.$confirm(msg, {
          confirmButtonText: this.$i18n.t('button.confirm'),
          cancelButtonText: this.$i18n.t('button.cancel'),
          type: 'warning'
        }).then(_ => { 
          this.loading = true;        
          apiCreateTraining({ headers: authHeader(), custSapCode:this.custSapCode  }).then((response) => {    
            if(response.status == 200){
              this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});     
              this.findData();
            }else{
              this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
            }
            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            console.log(err);
          });
    
          done();
        }).catch(_ => {});   
        
      }else{
        this.$message({ type: "error", message: this.$i18n.t('msg.pleaseSelectCustomerNo'), duration: 800});
      }
    }
  }
};
</script>
